import { render, staticRenderFns } from "./Quicklook.vue?vue&type=template&id=1bcf75bb"
import script from "./Quicklook.vue?vue&type=script&lang=js"
export * from "./Quicklook.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports